var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthereum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 2000,
    viewBox: "0 0 1949.9 1560.3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#3c3c3b}.st1{opacity:.6}.st2{clip-path:url(#SVGID_2_);fill:#010101}.st3{opacity:.45}.st4{clip-path:url(#SVGID_4_);fill:#010101}.st5{opacity:.8}.st6,.st7,.st8{clip-path:url(#SVGID_6_);fill:#010101}.st7,.st8{clip-path:url(#SVGID_8_)}.st8{clip-path:url(#SVGID_10_)}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 111.27)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m175.9 1241.9c0 4.3-3.6 7.8-7.9 7.8h-152.2c3.8 37.6 32.1 71.9 71.9 71.9 27.2 0 47.4-10.4 62.6-32.1 2.2-3 5.5-4.9 9.7-3.1 2.3 1 3.9 3.1 4.3 5.5 0.4 2.5-0.3 3.9-1 5.3-15.3 26.7-45.8 39.8-75.7 39.8-51.2 0-87.7-45.8-87.7-94.8s36.5-94.8 87.7-94.8c51.2-0.1 88.2 45.6 88.3 94.5m-16.3-7.4c-3.3-37.6-32.1-71.9-71.9-71.9s-68.1 34.3-71.9 71.9zm201-83.4c4.4 0 7.6 3.8 7.6 7.6 0 4.4-3.3 7.6-7.6 7.6h-40.8v160.1c0 3.8-3.3 7.6-7.6 7.6-4.4 0-7.6-3.8-7.6-7.6v-160.1h-39.2c-4.4 0-7.6-3.3-7.6-7.6 0-3.8 3.3-7.6 7.6-7.6h39.2v-58.6c0-3.7 2.5-7.1 6.1-7.7 5.1-0.8 9.1 2.7 9.1 7.5v58.8zm248.9 77.4v97c0 4.4-3.8 7.6-7.6 7.6-4.4 0-7.6-3.3-7.6-7.6v-97c0-32.7-18.5-65.4-55-65.4-46.8 0-67 40.9-64.3 82.8 0 1.1 0.5 6 0.5 6.5v72.8c0 3.7-2.5 7.1-6.1 7.7-5.1 0.8-9.1-2.7-9.1-7.5v-318.6c0-3.8 3.3-7.6 7.6-7.6 4.4 0 7.6 3.8 7.6 7.6v180.3c13.1-23.4 36.5-39.2 63.7-39.2 44.7 0 70.3 39.2 70.3 80.6m272.9 13.4c0 4.3-3.6 7.8-7.9 7.8h-152.3c3.8 37.6 32.1 71.9 71.9 71.9 27.2 0 47.4-10.4 62.6-32.1 2.2-3 5.5-4.9 9.7-3.1 2.3 1 3.9 3.1 4.3 5.5 0.4 2.5-0.3 3.9-1 5.3-15.3 26.7-45.8 39.8-75.7 39.8-51.2 0-87.7-45.8-87.7-94.8s36.5-94.8 87.7-94.8c51.3-0.1 88.3 45.6 88.4 94.5m-16.4-7.4c-3.3-37.6-32.1-71.9-71.9-71.9s-68.1 34.3-71.9 71.9zm203.2-76.3c0 4.9-2.7 7.6-7.1 8.2-44.7 6.5-64.8 43-64.8 85.5v72.8c0 3.7-2.5 7.1-6.1 7.7-5.1 0.8-9.1-2.7-9.1-7.5v-165.9c0-3.7 2.5-7.1 6.1-7.7 5.1-0.8 9.1 2.7 9.1 7.5v33.8c12.5-21.2 37.6-41.4 63.7-41.4 3.8-0.1 8.2 2.7 8.2 7m250 83.7c0 4.3-3.6 7.8-7.9 7.8h-152.2c3.8 37.6 32.1 71.9 71.9 71.9 27.2 0 47.4-10.4 62.6-32.1 2.2-3 5.5-4.9 9.7-3.1 2.3 1 3.9 3.1 4.3 5.5 0.4 2.5-0.3 3.9-1 5.3-15.3 26.7-45.8 39.8-75.7 39.8-51.2 0-87.7-45.8-87.7-94.8s36.5-94.8 87.7-94.8c51.2-0.1 88.2 45.6 88.3 94.5m-16.3-7.4c-3.3-37.6-32.1-71.9-71.9-71.9s-68.1 34.3-71.9 71.9zm262-74.4v166.3c0 4.4-3.8 7.6-7.6 7.6-4.4 0-7.6-3.3-7.6-7.6v-31.6c-12.5 25.1-34.9 43-63.2 43-45.2 0-70.3-39.2-70.3-80.6v-97.5c0-3.8 3.3-7.6 7.6-7.6 4.4 0 7.6 3.8 7.6 7.6v97.5c0 32.7 18.5 65.4 55 65.4 51.2 0 63.2-47.9 63.2-100.8v-62.1c0-4.4 4.4-8.9 9.8-7.3 3.3 1.1 5.5 4.3 5.5 7.7m385 67.8v97.5c0 4.4-3.8 7.6-7.6 7.6-4.4 0-7.6-3.3-7.6-7.6v-97.5c0-32.7-18.5-64.8-55-64.8-45.8 0-63.2 49-63.2 87.1v75.2c0 4.4-3.8 7.6-7.6 7.6-4.4 0-7.6-3.3-7.6-7.6v-97.5c0-32.7-18.5-64.8-55-64.8-46.3 0-65.4 36.5-63.7 85 0 1.1 0.5 3.3 0 3.8v73.3c0 3.7-2.5 7.1-6.2 7.7-5.1 0.8-9.1-2.7-9.1-7.5v-166.4c0-3.7 2.5-7.1 6.1-7.7 5.1-0.8 9.1 2.7 9.1 7.5v27.8c13.1-23.4 36.5-38.7 63.7-38.7 31 0 55 19.6 64.8 48.5 12.5-28.3 37-48.5 68.6-48.5 44.7 0 70.3 38.6 70.3 80"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "m720.6 306.4h508.7v266h-508.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    overflow: "visible",
    xlinkHref: "#SVGID_1_"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m975 306.4-254.4 115.7 254.4 150.3 254.3-150.3z",
    clipPath: "url(#SVGID_2_)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "m720.6 0h254.4v572.4h-254.4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    overflow: "visible",
    xlinkHref: "#SVGID_3_"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M 720.6,422.1 975,572.4 V 0 Z",
    clipPath: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "m975 0h254.4v572.4h-254.4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    overflow: "visible",
    xlinkHref: "#SVGID_5_"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m975 0v572.4l254.3-150.3z",
    clipPath: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "m720.6 470.3h254.4v358.4h-254.4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    overflow: "visible",
    xlinkHref: "#SVGID_7_"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m720.6 470.3 254.4 358.4v-208.1z",
    clipPath: "url(#SVGID_8_)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "m975 470.3h254.5v358.4h-254.5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    overflow: "visible",
    xlinkHref: "#SVGID_9_"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m975 620.6v208.1l254.5-358.4z",
    clipPath: "url(#SVGID_10_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.a4b0b34364b4196e7906958a80f3dc5d.svg";
export { ForwardRef as ReactComponent };